export function omitBrowserLocationParams(param: string): void {
  const url = new URL(window.location.href);
  let wasChanged: boolean = false;

  const search = new URLSearchParams(window.location.search);

  if (search.has(param)) {
    wasChanged = true;
    search.delete(param);
    const searchStr = search.toString();
    url.search = searchStr.length === 0 ? "" : "?" + searchStr;
  }

  const resultUrl = url.toString();

  if (wasChanged) {
    window.history.replaceState(window.history.state, document.title, resultUrl);
  }
}
